import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { PlantWeatherSensorIds } from "./weather.js";
export const Interval = z.object({
    gte: ZDate,
    lt: ZDate,
});
export const PointDD = z.object({
    lat: z.number(),
    lon: z.number(),
});
export const GetOpModesArgs = z.object({ plantId: z.number() });
export const GetOpModesResponse = z.object({
    opModes: z.array(z.object({ id: z.string(), name: z.string() })),
});
export const GetOpModeEventsArgs = z.object({
    plantId: z.number(),
    opModeFilter: z.nullable(z.array(z.string())),
    interval: Interval,
});
export const GetOpModeEventsResponse = z.object({
    events: z.array(z.object({
        id: z.string(),
        opModeId: z.string(),
        start: ZDate,
        end: ZDate,
        fuelConsumedM3: z.number(),
    })),
});
export const GetOpModeEventDetailsArgs = z.object({
    opModeEventId: z.string(),
});
export const GetOpModeEventDetailsResponse = z.object({
    track: z.array(z.tuple([
        ZDate,
        z.object({
            knots: z.nullable(z.number()),
            p: z.nullable(PointDD),
            heading: z.nullable(z.number()),
        }),
    ])),
    weather: z.array(z.tuple([ZDate, PlantWeatherSensorIds])),
});
export const GetFuelPerModeAndDateRefArgs = z.object({
    plantId: z.number(),
    interval: Interval,
    groupBy: z.enum(["month", "day"]),
});
export const GetFuelPerModeAndDateRefResponse = z.object({
    data: z.array(z.object({
        ref: ZDate,
        opModeEvents: z.array(z.object({
            opModeId: z.nullable(z.string()),
            tonnesMdo: z.number(),
            tonnesGas: z.number(),
            tonnesCO2: z.nullable(z.number()),
            tonnesNOx: z.nullable(z.number()),
            tonnesSOx: z.nullable(z.number()),
        })),
    })),
});
export const GetFuelUsedPerModeArgs = z.object({
    plantId: z.number(),
    interval: Interval,
});
export const GetFuelUsedPerModeResponse = z.object({
    opModes: z.array(z.object({
        opModeId: z.nullable(z.string()),
        averageTonnesPerDay: z.number(),
    })),
});
export const GetOpModeTimeAllocationArgs = z.object({
    plantId: z.number(),
    interval: Interval,
});
export const GetOpModeTimeAllocationResponse = z.object({
    opModes: z.array(z.object({
        opModeId: z.nullable(z.string()),
        percentage: z.number(),
    })),
    percentageTimeInShorePower: z.number(),
});
//# sourceMappingURL=unisea.js.map